// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const GEO_UF = {
  AC: 'GEO_UF1',
  AL: 'GEO_UF2',
  AM: 'GEO_UF3',
  AP: 'GEO_UF4',
  BA: 'GEO_UF5',
  CE: 'GEO_UF6',
  DF: 'GEO_UF7',
  ES: 'GEO_UF8',
  GO: 'GEO_UF9',
  MA: 'GEO_UF10',
  MG: 'GEO_UF11',
  MS: 'GEO_UF12',
  MT: 'GEO_UF13',
  PA: 'GEO_UF14',
  PB: 'GEO_UF15',
  PE: 'GEO_UF16',
  PI: 'GEO_UF17',
  PR: 'GEO_UF18',
  RJ: 'GEO_UF19',
  RN: 'GEO_UF20',
  RO: 'GEO_UF21',
  RR: 'GEO_UF22',
  RS: 'GEO_UF23',
  SC: 'GEO_UF24',
  SE: 'GEO_UF25',
  SP: 'GEO_UF26',
  TO: 'GEO_UF27',
  EX: 'GEO_UF28',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    GEO_UF1: 1,
    GEO_UF2: 2,
    GEO_UF3: 3,
    GEO_UF4: 4,
    GEO_UF5: 5,
    GEO_UF6: 6,
    GEO_UF7: 7,
    GEO_UF8: 8,
    GEO_UF9: 9,
    GEO_UF10: 10,
    GEO_UF11: 11,
    GEO_UF12: 12,
    GEO_UF13: 13,
    GEO_UF14: 14,
    GEO_UF15: 15,
    GEO_UF16: 16,
    GEO_UF17: 17,
    GEO_UF18: 18,
    GEO_UF19: 19,
    GEO_UF20: 20,
    GEO_UF21: 21,
    GEO_UF22: 22,
    GEO_UF23: 23,
    GEO_UF24: 24,
    GEO_UF25: 25,
    GEO_UF26: 26,
    GEO_UF27: 27,
    GEO_UF28: 28
  }
}
